import { render, staticRenderFns } from "./ProgramRecommendationCard.vue?vue&type=template&id=52efbd92&scoped=true&"
import script from "./ProgramRecommendationCard.vue?vue&type=script&lang=js&"
export * from "./ProgramRecommendationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efbd92",
  null
  
)

export default component.exports